import { FONT_FAMILY } from 'styles/typography'
const themeStyles = colors => {
  const styles = {
    container: {
      position: 'relative',
      fontFamily: FONT_FAMILY,
      height: '100%',
      padding: 30,
      color: colors.approxBlack,
      backgroundColor: colors.lighterSmoke
    },
    contentArea: {
      backgroundColor: colors.white,
      minHeight: 450
    },
    fieldName: {
      fontFamily: FONT_FAMILY,
      fontSize: 9,
      fontWeight: 700
    },
    itemName: {
      overflowWrap: 'anywhere',
      fontFamily: FONT_FAMILY,
      fontSize: 14,
      fontWeight: 700
    },
    itemContent: {
      fontFamily: FONT_FAMILY,
      fontSize: 14,
      fontWeight: 400
    },
    noPaddingTop: {
      paddingTop: 0
    },
    smallDiveder: {
      margin: 15
    }
  }
  return styles
}

export default themeStyles

